<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card style="border-radius: 10px">
        <v-toolbar class="elevation-0" color="black" dark
          ><v-toolbar-title>{{
            editedIndex == -1
              ? "Create Dine In Store District"
              : "Edit Dine In Store District"
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('onClosed')"
            ><v-icon>close</v-icon></v-btn
          ></v-toolbar
        >
        <v-card-text>
          <v-form v-model="valid" ref="formStoreDistrict">
            <div style="display: flex; justify-content: center">
              <div v-if="newImageSrc" style="position: relative">
                <div
                  style="
                    position: absolute;
                    top: 50%;
                    right: 50%;
                    transform: translate(50%, -50%);
                    z-index: 1;
                  "
                  v-if="
                    (newImageSrc && newImageSrc != null) ||
                    form.store_district_image != null
                  "
                >
                  <v-btn
                    color="white"
                    icon
                    @click="$refs.DistrictImageInput.click()"
                  >
                    <v-icon color="black" size="36">mdi-pencil-circle</v-icon>
                  </v-btn>
                </div>
                <v-img
                  style="position: relative; z-index: 0"
                  :src="newImageSrc"
                  :style="{
                    width: '240px',
                    height: '135px',
                    border: '1px solid gray',
                  }"
                  alt="Cropped Image"
                />
              </div>
              <v-card
                @click="$refs.DistrictImageInput.click()"
                width="240px"
                height="135px"
                color="grey"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                "
                v-else-if="form.store_district_image == null"
              >
                <v-icon color="white" size="36">mdi-plus-circle</v-icon>
              </v-card>
              <div v-else style="position: relative">
                <v-img
                  :src="form.store_district_image"
                  :style="{
                    width: '240px',
                    height: '135px',
                    border: '1px solid gray',
                  }"
                  style="position: relative; z-index: 0"
                  alt="Cropped Image"
                />
                <div
                  style="
                    position: absolute;
                    top: 50%;
                    right: 50%;
                    transform: translate(50%, -50%);
                    z-index: 1;
                  "
                  v-if="
                    (newImageSrc && newImageSrc != null) ||
                    form.store_district_image != null
                  "
                >
                  <v-btn
                    color="white"
                    icon
                    @click="$refs.DistrictImageInput.click()"
                  >
                    <v-icon color="black" size="36">mdi-pencil-circle</v-icon>
                  </v-btn>
                </div>
              </div>
              <input
                style="display: none"
                type="file"
                @change="onDistrictImageSelected"
                ref="DistrictImageInput"
                accept="image/jpg, image/jpeg"
              />
            </div>
            <div style="margin-bottom: 20px"></div>

            <v-layout wrap>
              <v-flex xs12 class="pa-1">
                <v-autocomplete
                  label="Select Province"
                  :items="provinceData"
                  item-value="province_id"
                  item-text="province_name_en"
                  hide-details
                  clearable
                  v-model="form.store_district_province_id"
                  @change="selectedProvince()"
                  :rules="[(v) => !!v || 'required']"
                ></v-autocomplete
              ></v-flex>
              <v-flex xs12 class="pa-1">
                <v-autocomplete
                  :disabled="form.store_district_province_id == null"
                  label="Select District"
                  :items="filteredDistrictList"
                  item-value="district_id"
                  item-text="district_name_en"
                  hide-details
                  clearable
                  v-model="form.store_district_district_id"
                  :loading="isLoadingDistrict"
                ></v-autocomplete
              ></v-flex>
            </v-layout> </v-form
        ></v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            style="border-radius: 10px"
            @click="clear()"
            color="error"
            :disabled="isLoading"
            >clear</v-btn
          >
          <v-btn
            depressed
            style="border-radius: 10px"
            @click="submit()"
            color="success"
            :loading="isLoading"
            >save</v-btn
          >
        </v-card-actions></v-card
      >
    </v-dialog>

    <v-dialog v-model="cropedDialog" max-width="65vw" persistent>
      <v-card>
        <imageCropper
          :aspectRatio="16 / 9"
          :imageName="''"
          :imgSrc="croppedImageSrc"
          :height="300"
          @close="cropedDialog = false"
          @getCroped="getCroppedImage($event)"
          v-if="croppedImageSrc != null"
        ></imageCropper>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import imageCropper from "@/components/Plugins/imageCropper.vue";
export default {
  props: ["dialog", "editedIndex", "selectedItem", "unAvailableDistrict"],
  data() {
    return {
      valid: true,
      form: {
        store_district_image: null,
        store_district_district_id: null,
        store_district_province_id: null,
      },
      districtList: [],
      newImageSrc: null,
      cropedDialog: false,
      croppedImageSrc: null,
      isLoadingDistrict: false,
      isLoading: false,
    };
  },
  components: {
    imageCropper,
  },
  watch: {
    async dialog() {
      if (this.dialog == true) {
        this.resetForm();
        if (this.editedIndex == -1) {
          this.$refs.formStoreDistrict.resetValidation();
          return;
        }
        this.form.store_district_image = this.selectedItem.store_district_image;
        this.form.store_district_province_id =
          this.selectedItem.store_district_district.district_province;
        this.form.store_district_district_id =
          this.selectedItem.store_district_district.district_id;
        this.form.store_district_id = this.selectedItem.store_district_id;
        await this.getDistrictList(this.form.store_district_province_id);
      }
    },
  },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    filteredDistrictList() {
      return this.districtList.filter(
        (val) =>
          val.district_id == this.form.store_district_district_id ||
          !this.unAvailableDistrict.includes(val.district_id)
      );
    },
  },

  methods: {
    ...mapActions({
      getDistrictCore: "fetchProvinceBack/getDistrictCore",
    }),
    resetForm() {
      this.form = {
        store_district_image: null,
        store_district_district_id: null,
        store_district_province_id: null,
      };
      this.newImageSrc = null;
      this.croppedImageSrc = null;
    },
    onDistrictImageSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.cropedDialog = true;
        this.croppedImageSrc = reader.result;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    submit() {
      if (!this.$refs.formStoreDistrict.validate()) return;
      let _this = this;
      this.isLoading = true;
      this.$emit("onSaved", {
        done() {
          _this.isLoading = false;
        },
        form: this.form,
        newImageSrc: this.newImageSrc,
      });
    },
    clear() {},
    getCroppedImage(value) {
      this.newImageSrc = value;
      this.cropedDialog = false;
      this.croppedImageSrc = "";
    },
    async getDistrictList(provinceId) {
      this.isLoadingDistrict = true;
      this.districtList = await this.getDistrictCore(provinceId);
      this.isLoadingDistrict = false;
      return;
    },
    selectedProvince() {
      this.form.store_district_district_id = null;
      this.getDistrictList(this.form.store_district_province_id);
    },
  },
};
</script>

<style lang="scss" scoped></style>
